import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-77e1d37c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-base" }

import useAccess from "@/composable/useAccess";
import { isFeatureKeyOn } from "@/composable/useEnterpriseFeature";
import { storageConfig } from "@/state/api/userState";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'MoreMenuLink',
  props: {
		name: {
			type: String,
			default: "",
		},
		title: {
			type: Object,
			default: {},
		},
		routeName: {
			type: String,
			default: "",
		},
		icon: {
			type: Object,
			default: {},
		},
		featureFlag: {
			type: String,
			default: "",
		},
		userRoles: {
			type: Array,
			default: [],
		},
		resources: {
			type: Array,
			default: [],
		},
		permissions: {
			type: Array,
			default: [],
		},
	},
  setup(__props) {

	const props = __props;

	const checkAccess = (resources: any) => {
		return  useAccess("resource", resources);
	}

	// Same role gate as MenuLink: empty array means "no role restriction"
	// (Root short-circuits inside useAccess).
	const checkRoles = (roles: any) => {
		if (!roles || (roles as any).length === 0) return true;
		return useAccess("visibility", roles);
	}


return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return ((__props.name == 'profile' || __props.name == 'settings' || __props.name == 'logout')
			&& _unref(isFeatureKeyOn)(__props.featureFlag)
			&& (__props.resources.length === 0 || checkAccess(__props.resources) || checkRoles(__props.userRoles)))
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: { name: __props.routeName },
        tag: "a",
        class: _normalizeClass([
			{
				'font-normal  hover:text-accent text-gray-400 flex flex-row space-x-3 items-center': true,
			},
		])
      }, {
        default: _withCtx(() => [
          (__props.icon != {})
            ? (_openBlock(), _createBlock(_component_Icon, {
                key: 0,
                src: __props.icon.active,
                css: "w-5 h-5 opacity-60"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(storageConfig)?.lang ? __props.title[_unref(storageConfig).lang] : __props.title.en), 1)
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})